module.exports = __webpack_public_path__ + "static/media/NoirPro-Heavy.873c8fa8.woff2";